import React from "react";
import * as PropTypes from "prop-types";
import { labeledValuesPropType } from "../../propTypes";
import { withStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";

const styles = {
  label: {
    whiteSpace: "nowrap"
  }
};

const ItemChooser = props => {
  const inputLabel = React.useRef(null);

  const [labelWidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <form className="chooser">
      <FormControl variant="outlined" component="div">
        <InputLabel
          ref={inputLabel}
          htmlFor={props.id}
          classes={{
            root: props.classes.label
          }}
        >
          {props.label}
        </InputLabel>
        <Select
          native={true}
          value={props.value}
          input={
            <OutlinedInput
              id={props.id}
              margin="dense"
              labelWidth={labelWidth}
            />
          }
          onChange={event => {
            props.onChange(event.target.value);
          }}
        >
          {props.items.map(({ value, label }) => (
            <option key={value} value={value}>
              {label || value}
            </option>
          ))}
        </Select>
      </FormControl>
    </form>
  );
};

ItemChooser.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  items: labeledValuesPropType,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(ItemChooser);
